<ng-container *ngIf="displayCurrentStatus$ | async as currentStatus">
	<div
		*ngIf="currentStatus"
		[routerLink]="getRouterLink(ROUTE_PATH.STATUS)"
		class="container-status w-100"
		[ngClass]="{ 'status-msg': currentStatus }"
	>
		<div class="container h-100" translate>
			We are currently experiencing some disruptions in the operation of the
			SeltronHome platform. Check platform status page for more information.
		</div>
	</div>
</ng-container>
